/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OpProcedureOrderItem from './op-procedure-order-item';
import OpProcedureOrderItemDetail from './op-procedure-order-item-detail';
import OpProcedureOrderItemUpdate from './op-procedure-order-item-update';
import OpProcedureOrderItemDeleteDialog from './op-procedure-order-item-delete-dialog';

const OpProcedureOrderItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OpProcedureOrderItem />} />
    <Route path="new" element={<OpProcedureOrderItemUpdate />} />
    <Route path=":id">
      <Route index element={<OpProcedureOrderItemDetail />} />
      <Route path="edit" element={<OpProcedureOrderItemUpdate />} />
      <Route path="delete" element={<OpProcedureOrderItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OpProcedureOrderItemRoutes;
